export const phaseLabels: { [key in Phase]: string } = {
    Upcoming: 'Upcoming',
    Setup: 'Setup',
    Launch: 'Launch',
    Delivery: 'Delivery',
    Post: 'Post',
};
